import "./GrowthStrategyConsulting.module.css";
import Header from "@/reusable_sections/Header";
import Growthstrategyconsultation from "./sections/Growthstrategyconsultation";
import Roadmap from "./sections/Roadmap";
import WhyItMatters from "./sections/WhyItMatters";
import Footer from "@/reusable_sections/Footer";
export default function GrowthStrategyConsultingPage() {
  return <div>
      <Header />
      <Growthstrategyconsultation />
      <Roadmap />
      <WhyItMatters />
      <Footer />
    </div>;
}